import type { FaireProductEntity } from "../../entity_types/product";

export const p_9p28hbsm65: FaireProductEntity = {
  token: "p_9p28hbsm65",
  type: "product",
  name: "Bao Bun/Dumpling Rainbow Surprise 48ct Case",
  brandToken: "b_wdpbx8b4ft",
  brandName: "EXPRESS RETAIL SOLUTIONS INC.",
  imageUrl:
    "https://cdn.faire.com/fastly/215b2f914f06f9c39d17d761d09c3c849d9f38a1b7272feaad710d77db43700a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/60e1ec1aedf42ce0d37e838d128831ccff9960902bb5d420c5a738b99ed1bac2.jpeg",
    "https://cdn.faire.com/fastly/6218f9e3d7ca7ad0fa2109964a7b35675bde23aa9d80cd30af98d704a998768a.jpeg",
  ],
  priceDollars: 264,
  description:
    "Rainbow Surprise Bao Bun Squishy — Toy Master 48-Count Retail-Ready Master Case\n\nGet ready for the most colorful impulse buy on your shelves! Toy Master's Rainbow Surprise Bao Bun combines the irresistible appeal of slow-rise squishy toys with the thrill of a surprise reveal \n\nEach individually packaged unit includes:\n🌈 A vibrant, slow-rise PU Bao Bun/Dumpling squishy — soft, satisfying, and built to last\n🎉 A mystery surprise inside — the excitement of not knowing keeps kids coming back\n✨ Bold rainbow colorways — eye-catching and shelf-stopping from across the aisle\n🎁 Individual retail-ready packaging — shelf ready straight out of the box\n\nWhy it sells:\nSquishy toys and surprise reveals are two of the hottest trends in impulse retail — and Rainbow Surprise Bao Bun delivers both in one irresistible package. The vibrant colors create instant visual impact on any display, and the mystery element drives repeat purchases as kids collect every color and surprise.\n\nPerfect for:\nGift shops · Toy aisles · Checkout counters · Party supply stores · Candy & novelty shops · Resort & attraction retail · Birthday party favors\nCase Details:\n📦 48 units per master case | Each unit sold individually",
  tags: [],
  msrpDollars: 479.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:46.718Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
